module.exports = __webpack_public_path__ + "static/img/loginbg.64555839.svg";